module.exports = __webpack_public_path__ + "static/media/twitterIcon.37816beb.svg";